import { asapScheduler, SchedulerLike } from 'rxjs';

/**
 * Global rx scheduler. Used for switching scheduler for unit tests.
 * Overridden in core/test/global.js
 */
export type IScheduler = SchedulerLike;

export const SchedulerProvider: {
  provide: string;
  useValue: IScheduler;
} = {
  provide: 'scheduler',
  useValue: asapScheduler,
};
